import { render, staticRenderFns } from "./AddressForm.DynamicView.vue?vue&type=template&id=36f3c9cc&scoped=true"
import script from "./AddressForm.DynamicView.vue?vue&type=script&lang=ts"
export * from "./AddressForm.DynamicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3c9cc",
  null
  
)

export default component.exports